import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import '../styles/Clients.css';

const Clients = () => {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');

  const { canCreate, canUpdate, canDelete } = useAuth();

  useEffect(() => {
    loadClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const loadClients = async () => {
    try {
      setLoading(true);
      const params = search ? { search } : {};
      const response = await api.getClients(params);
      if (response.data) {
        setClients(response.data.clients || response.data);
      }
      setError('');
    } catch (err) {
      setError('Failed to load clients');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (clientId) => {
    navigate(`/clients/edit/${clientId}`);
  };

  const handleDelete = async (clientId) => {
    if (!window.confirm('Are you sure you want to delete this client?')) {
      return;
    }
    try {
      await api.deleteClient(clientId);
      loadClients();
    } catch (err) {
      setError('Failed to delete client');
    }
  };

  const handleViewPrint = (clientId) => {
    navigate(`/clients/print/${clientId}`);
  };

  return (
    <div className="content-container">
      <div className="page-header-section">
        <h1>Clients</h1>
        <div className="header-actions">
          <button onClick={loadClients} className="btn btn-secondary">
            Refresh
          </button>
          {canCreate('clients') && (
            <button onClick={() => navigate('/clients/new')} className="btn btn-primary">
              Add Client
            </button>
          )}
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="search-section">
        <input
          type="text"
          placeholder="Search clients..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
      </div>

      {loading ? (
        <div className="loading">Loading clients...</div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Client ID</th>
                
                <th>Client Name</th>
                {/* <th>Contact Person</th> */}
                <th>Email</th>
                <th>Phone</th>
                <th>City</th>
                <th>Domains</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {clients.length === 0 ? (
                <tr>
                  <td colSpan="9" className="text-center">
                    No clients found
                  </td>
                </tr>
              ) : (
                clients.map((client) => (
                  <tr key={client.client_id}>
                    <td data-label="Client ID">{client.client_id}</td>
                 
                    <td data-label="Client Name">{client.client_name || '-'}</td>
                    {/* <td data-label="Contact Person">{client.person_name || '-'}</td> */}
                    <td data-label="Email">{client.email || '-'}</td>
                    <td data-label="Phone">{client.phone || '-'}</td>
                    <td data-label="City">{client.city || '-'}</td>
                    <td className="domains-cell" data-label="Domains">
                      {Array.isArray(client.domains) 
                        ? client.domains.slice(0, 2).join(', ') + (client.domains.length > 2 ? '...' : '')
                        : client.domains || '-'}
                    </td>
                    <td className="actions-cell" data-label="">
                      <button
                        onClick={() => handleViewPrint(client.client_id)}
                        className="btn btn-sm btn-info"
                        title="View and Print Order Form"
                      >
                        📄 View/Print
                      </button>
                      {canUpdate('clients') && (
                        <button
                          onClick={() => handleEdit(client.client_id)}
                          className="btn btn-sm btn-secondary"
                        >
                          Edit
                        </button>
                      )}
                      {canDelete('clients') && (
                        <button
                          onClick={() => handleDelete(client.client_id)}
                          className="btn btn-sm btn-danger"
                        >
                          Delete
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Clients;
